/**
 * @flow
 * @relayHash 38a0b65f436f0a674e47fc2414bcd602
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type JobGenerationWidgetQueryVariables = {||};
export type JobGenerationWidgetQueryResponse = {|
  +ordersPendingJobGeneration: $ReadOnlyArray<{|
    +order: {|
      +id: string
    |},
    +pendingCount: number,
  |}>
|};
export type JobGenerationWidgetQuery = {|
  variables: JobGenerationWidgetQueryVariables,
  response: JobGenerationWidgetQueryResponse,
|};
*/


/*
query JobGenerationWidgetQuery {
  ordersPendingJobGeneration {
    order {
      id
    }
    pendingCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ordersPendingJobGeneration",
    "storageKey": null,
    "args": null,
    "concreteType": "OrderPendingJobGeneration",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "pendingCount",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "JobGenerationWidgetQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "JobGenerationWidgetQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "JobGenerationWidgetQuery",
    "id": null,
    "text": "query JobGenerationWidgetQuery {\n  ordersPendingJobGeneration {\n    order {\n      id\n    }\n    pendingCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37d22cb76a8a1e7431ea5b2fb2db4883';
module.exports = node;
